import React from 'react';
import Svg from '../Svg';

const IconCornerRightDown = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2594 5.07842C9.30901 5.00078 8.09666 5 6.4 5H3C2.44772 5 2 4.55229 2 4C2 3.44772 2.44772 3 3 3L6.44441 3C8.08696 2.99999 9.38091 2.99999 10.4222 3.08507C11.4846 3.17186 12.3717 3.35217 13.1779 3.76295C14.4951 4.43407 15.5659 5.50493 16.237 6.82207C16.6478 7.62827 16.8281 8.51543 16.9149 9.57778C17 10.6191 17 11.9131 17 13.5556L17 17.5858L20.2929 14.2929C20.6834 13.9024 21.3166 13.9024 21.7071 14.2929C22.0976 14.6834 22.0976 15.3166 21.7071 15.7071L16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21C15.7348 21 15.4804 20.8946 15.2929 20.7071L10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929C10.6834 13.9024 11.3166 13.9024 11.7071 14.2929L15 17.5858L15 13.6C15 11.9033 14.9992 10.691 14.9216 9.74064C14.8449 8.80197 14.6982 8.20731 14.455 7.73005C13.9757 6.78924 13.2108 6.02433 12.27 5.54497C11.7927 5.30179 11.198 5.15512 10.2594 5.07842Z"
    />
  </Svg>
);

export default IconCornerRightDown;
